import { c as _c } from "react/compiler-runtime";
import { Location } from 'history';
import { ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { TeamRole } from '../../../../../typings/TeamMember.interface';
import { withStaticProperties } from '../../utils/withStaticProperties';
import { usePermissionAwareDisabled } from '../contexts/TeamPermissionContext';
import { ClickableArea } from './base/Button';
import { StyledCardSection } from './base/Card';
import Icon, { IconName } from './base/Icon';
import Loading from './base/Loading';
import Text from './base/Text';
import Tooltip from './base/Tooltip';
import Dropdown, { DropdownProps } from './Dropdown';
import { Div } from './helpers/StyledUtils';
import Search from './Search';
export interface DropdownMenuOption {
  id?: string;
  label: string;
  description?: string;
  icon?: IconName | React.ReactElement;
  danger?: boolean;
  mono?: boolean;
  disabled?: boolean;
  tooltip?: string;
  selected?: boolean;
  action_icon?: IconName;
  role?: TeamRole;
  block?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  to?: string | Partial<Location> | ((location: Location) => string | Partial<Location>);
}
export interface DropdownMenuProps extends Omit<DropdownProps, 'children'> {
  search?: boolean;
  search_placeholder?: string;
  search_term?: string;
  setSearchTerm?: (value: string) => void;
  getItemsFooter?: (search_term: string) => ReactNode;
  search_is_loading?: boolean;
  options: DropdownMenuOption[];
  search_ref?: React.RefObject<HTMLInputElement | null>;
  options_max_height?: number | {
    px?: number;
    vh?: number;
    pc?: number;
    raw?: string;
  };
}
const StyledScrollableArea = styled(Div)`
  flex-grow: 1;
  overflow-y: auto;
  box-sizing: border-box;
  flex-grow: 1;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const DropdownMenu: React.FC<DropdownMenuProps> = t0 => {
  const $ = _c(35);
  let getItemsFooter;
  let options;
  let options_max_height;
  let props;
  let search_placeholder;
  let search_ref;
  let setSearchTerm;
  let show_search;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      options,
      search_ref,
      search: show_search,
      search_placeholder,
      search_term: t1,
      search_is_loading: t2,
      setSearchTerm,
      getItemsFooter,
      options_max_height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = getItemsFooter;
    $[2] = options;
    $[3] = options_max_height;
    $[4] = props;
    $[5] = search_placeholder;
    $[6] = search_ref;
    $[7] = setSearchTerm;
    $[8] = show_search;
    $[9] = t1;
    $[10] = t2;
  } else {
    getItemsFooter = $[1];
    options = $[2];
    options_max_height = $[3];
    props = $[4];
    search_placeholder = $[5];
    search_ref = $[6];
    setSearchTerm = $[7];
    show_search = $[8];
    t1 = $[9];
    t2 = $[10];
  }
  const search_term = t1 === undefined ? "" : t1;
  const search_is_loading = t2 === undefined ? false : t2;
  let t3;
  if ($[11] !== props) {
    t3 = {
      ...props
    };
    $[11] = props;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const dropdown_props = t3;
  const [search, _setSearch] = useState(search_term);
  let t4;
  if ($[13] !== setSearchTerm) {
    t4 = value => {
      if (setSearchTerm) {
        setSearchTerm(value);
      }
      _setSearch(value);
    };
    $[13] = setSearchTerm;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const setSearch = t4;
  let t5;
  if ($[15] !== options || $[16] !== search) {
    t5 = search ? options.filter(option => option.label.toLowerCase().indexOf(search.toLowerCase()) > -1 || option.description && option.description.toLowerCase().indexOf(search.toLowerCase()) > -1) : options;
    $[15] = options;
    $[16] = search;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const filtered_options = t5;
  let t6;
  if ($[18] !== getItemsFooter || $[19] !== search_term) {
    t6 = getItemsFooter ? getItemsFooter(search_term) : null;
    $[18] = getItemsFooter;
    $[19] = search_term;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const items_footer = t6;
  let t7;
  if ($[21] !== dropdown_props || $[22] !== filtered_options || $[23] !== items_footer || $[24] !== options_max_height || $[25] !== search || $[26] !== search_is_loading || $[27] !== search_placeholder || $[28] !== search_ref || $[29] !== setSearch || $[30] !== show_search) {
    t7 = toggle => <>{show_search && <StyledCardSection><Search borderless={true} small={true} placeholder={search_placeholder} value={search} onChange={setSearch} search_ref={search_ref} /></StyledCardSection>}{search_is_loading ? <StyledCardSection p={3} flex={{
        align: "center",
        justify: "center"
      }}><Loading /></StyledCardSection> : filtered_options.length > 0 ? <StyledCardSection><StyledScrollableArea max_h={options_max_height || {
          px: 242
        }} p={1}>{filtered_options.map(option_0 => <DropdownMenuOptionItem key={option_0.id ?? option_0.label} toggle={toggle} {...option_0} disabled={Boolean(option_0.disabled || dropdown_props.disabled)} />)}</StyledScrollableArea></StyledCardSection> : <StyledCardSection p={{
        y: 2.5,
        x: 3
      }}><Text muted={true}><Icon icon="info" left={true} /> {search ? "No results..." : "No options..."}</Text></StyledCardSection>}{items_footer && <StyledCardSection>{items_footer}</StyledCardSection>}</>;
    $[21] = dropdown_props;
    $[22] = filtered_options;
    $[23] = items_footer;
    $[24] = options_max_height;
    $[25] = search;
    $[26] = search_is_loading;
    $[27] = search_placeholder;
    $[28] = search_ref;
    $[29] = setSearch;
    $[30] = show_search;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== dropdown_props || $[33] !== t7) {
    t8 = <Dropdown {...dropdown_props}>{t7}</Dropdown>;
    $[32] = dropdown_props;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
};
const StyledDropdownMenuOptionItem = styled.div(({
  theme
}) => css`
    border-radius: ${theme.radius.normal};
    user-select: none;

    a,
    button {
      border-radius: ${theme.radius.normal};

      &:focus-visible {
        box-shadow: none;
        outline: 2px solid ${theme.colors.outline.focus.primary};
        border-radius: ${theme.radius.small_inset};
        outline-offset: 1px;
      }
    }
  `);
export const DropdownMenuOptionItem = t0 => {
  const $ = _c(37);
  const {
    toggle,
    label,
    description,
    selected,
    icon,
    action_icon,
    onClick,
    to,
    tooltip,
    disabled: _disabled,
    danger,
    mono,
    role
  } = t0;
  const disabled = usePermissionAwareDisabled(_disabled, role);
  let t1;
  if ($[0] !== onClick || $[1] !== to || $[2] !== toggle) {
    t1 = to ? {
      to,
      as: Link,
      onClick: () => toggle?.(false)
    } : {
      onClick: e => {
        e.preventDefault();
        toggle?.(false);
        onClick && onClick(e);
      }
    };
    $[0] = onClick;
    $[1] = to;
    $[2] = toggle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      y: 1.5,
      x: 2
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "center",
      gap: 2
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== danger || $[7] !== disabled || $[8] !== icon) {
    t4 = icon ? typeof icon === "string" ? <Icon danger={danger} muted={!danger && !disabled} disabled={disabled} icon={icon} pointer={!disabled} /> : icon : null;
    $[6] = danger;
    $[7] = disabled;
    $[8] = icon;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = !!description;
  let t6;
  if ($[10] !== danger || $[11] !== disabled || $[12] !== label || $[13] !== mono || $[14] !== t5) {
    t6 = <Text disabled={disabled} danger={danger} ellipsis={true} semi={t5} mono={mono}>{label}</Text>;
    $[10] = danger;
    $[11] = disabled;
    $[12] = label;
    $[13] = mono;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== action_icon || $[17] !== disabled || $[18] !== selected) {
    t7 = action_icon ? <Icon primary={true} icon={action_icon} right={true} style={{
      marginLeft: "auto"
    }} pointer={!disabled} /> : selected && <Icon primary={true} icon="success_circle" right={true} style={{
      marginLeft: "auto"
    }} pointer={!disabled} />;
    $[16] = action_icon;
    $[17] = disabled;
    $[18] = selected;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t4 || $[21] !== t6 || $[22] !== t7) {
    t8 = <Div flex={t3}>{t4}{t6}{t7}</Div>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== description || $[25] !== disabled || $[26] !== icon) {
    t9 = description && <Text neutral={disabled} muted={!disabled} max_width="256px" text_wrap={true} p={icon ? {
      l: 6
    } : undefined}>{description}</Text>;
    $[24] = description;
    $[25] = disabled;
    $[26] = icon;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== danger || $[29] !== disabled || $[30] !== t1 || $[31] !== t8 || $[32] !== t9) {
    t10 = <ClickableArea {...t1} disabled={disabled} danger={danger} p={t2}>{t8}{t9}</ClickableArea>;
    $[28] = danger;
    $[29] = disabled;
    $[30] = t1;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  const content = t10;
  let t11;
  if ($[34] !== content || $[35] !== tooltip) {
    t11 = <StyledDropdownMenuOptionItem>{tooltip ? <Tooltip tooltip={tooltip} side="right" fill={true}>{content}</Tooltip> : content}</StyledDropdownMenuOptionItem>;
    $[34] = content;
    $[35] = tooltip;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
};
export const DropdownMenuPermission: React.FC<React.ComponentPropsWithRef<typeof DropdownMenu> & {
  role?: TeamRole;
}> = t0 => {
  const $ = _c(6);
  let dropdownMenuProps;
  let role;
  if ($[0] !== t0) {
    ({
      role,
      ...dropdownMenuProps
    } = t0);
    $[0] = t0;
    $[1] = dropdownMenuProps;
    $[2] = role;
  } else {
    dropdownMenuProps = $[1];
    role = $[2];
  }
  const disabled = usePermissionAwareDisabled(dropdownMenuProps.disabled, role);
  let t1;
  if ($[3] !== disabled || $[4] !== dropdownMenuProps) {
    t1 = <DropdownMenu {...dropdownMenuProps} disabled={disabled} />;
    $[3] = disabled;
    $[4] = dropdownMenuProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default withStaticProperties(DropdownMenu, {
  Permission: DropdownMenuPermission
});